import { colorMap } from "./constants"
import { ScryfallCard } from "@scryfall/api-types";



//card.color_identity - array
export function formatBackgroundURL(card: ScryfallCard.Normal, isHardMode: boolean) {
    const outType = card.power || card.toughness ? "creature" : "noncreature"
    var cid: string | undefined = ""
    if (isHardMode) {
        cid = "white"
    }
    else if (card.colors.length === 0) {
        cid = "colorless"
        if (card.type_line.includes('Land')) {
            cid = "multicolor"
        }
    } else if (card.colors.length > 1) {
        cid = "multicolor"
    }
    else if(card.colors[0] !== undefined){
        cid = colorMap[card.colors[0]]
    }
    return `${cid}-${outType}.png`
}
